<template>
	<v-modal
		:name="name"
		:width="width"
		:height="height"
		:adaptive="true"
		:scrollable="true"
		:pivotX="pivotX"
		:pivotY="pivotY"
		@closed="$emit('close')"
		classes="visible"
	>
		<!-- Header -->
		<div class="flex xs-12 xs-middle wrap p4 bg1" v-if="hasHeader">
			<div class="xs-6 fs5 fw7 lh125 c5">
				{{ headline }}
			</div>
			<div class="flex xs-right xs-6 fs5 fw7 lh125">
				<crm-icon
					size="large"
					color="c5"
					name="cross"
					class="cu2"
					@click.native="$modal.hide(name)"
				/>
			</div>
		</div>

		<!-- Body -->
		<div class="bg4">
			<slot></slot>
		</div>
	</v-modal>
</template>

<script>
/**
 * This component is responsible to render modal window
 * we use this: https://www.npmjs.com/package/vue-js-modal
 */
import CrmIcon from "@/components/CrmIcon"

export default {
	components: { CrmIcon },
	props: {
		/**
		 * Name of the modal
		 */
		name: {
			type: String,
			required: true
		},
		headline: {
			type: String,
			required: false
		},

		/**
		 * Whether to show header of the modal
		 */
		hasHeader: {
			type: Boolean,
			default: true
		},

		/**
		 * Width of modal window
		 */
		width: {
			type: [String, Number],
			default: 500
		},
		/**
		 * Height of modal window
		 */
		height: {
			type: [String, Number],
			default: "auto"
		},

		/**
		 * Horizontal position in %, default is 0.5 (meaning that modal box will be in the middle (50% from left) of the window
		 */
		pivotX: {
			type: Number,
			default: 0.5
		},

		/**
		 * Vertical position in %, default is 0.5 (meaning that modal box will be in the middle (50% from top) of the window
		 */
		pivotY: {
			type: Number,
			default: 0.5
		}
	}
}
</script>
